// extracted by mini-css-extract-plugin
export default {"confirmationModalHeader":"style_confirmationModalHeader__EtLzX","footer":"style_footer__sRkgc"};